import { types } from '../types/types';

const initialState = {
	bagListRowsInvalid: [],
	bagListRowsSaved: [],
	bagListRowsValid: [],
	bagRowProcess: [],
	totalRows: 0,
	fileDownload: [],
	numberOfRowsValid: 0,
	numberOfRowsSaved: 0,
	numberOfRowsInvalid: 0,
	isFetching:false,

	totalItems: 0,
	totalPages: 0,
	currentPage: 0,
	technologiesBulkListP:[]
};
export const importDataFinancialReducer = (state = initialState, action) => {

	switch (action.type) {

		case types.IMPORT_DATA_FINANCIAL:
			
			return {
				...state,
				bagListRowsInvalid: action.payload.bagListRowsInvalid,
				bagListRowsSaved: action.payload.bagListRowsSaved,
				bagListRowsValid: action.payload.bagListRowsValid,
				bagRowProcess: action.payload.bagRowProcess,
				totalRows: action.payload.totalRows,
				numberOfRowsValid: action.payload.numberOfRowsValid,
				numberOfRowsSaved: action.payload.numberOfRowsSaved,
				numberOfRowsInvalid: action.payload.numberOfRowsInvalid,
				totalItems: action.payload.totalItems,
          		totalPages: action.payload.totalPages,
          		currentPage: action.payload.currentPage,
				technologiesBulkListP: action.payload.technologysP
          		
			};
			break;

		case types.IMPORT_DATA_FINANCIAL_LOCAL_PAGINATION:
			
			return {
				...state,
				totalItems: action.payload.totalItems,
          		totalPages: action.payload.totalPages,
          		currentPage: action.payload.currentPage,
				technologiesBulkListP: action.payload.technologysP
			};
			break;

		case types.IMPORT_DATA_FINANCIAL_LOADING:
			return {
				...state,
				isFetching:true
			};
			break;

		case types.IMPORT_DATA_FINANCIAL_FINISH:
			return {
				...state,
				isFetching:false
			};

			break;

		case types.IMPORT_DATA_FINANCIAL_CLEAN:
			return {
				...state,
				bagListRowsInvalid: [],
				bagListRowsSaved: [],
				bagListRowsValid: [],
				bagRowProcess: [],
				totalRows: 0,
				numberOfRowsValid: 0,
				numberOfRowsSaved: 0,
				numberOfRowsInvalid: 0,

				isFetching:false,
				totalItems: 0,
				totalPages: 0,
				currentPage: 0,
				technologiesBulkListP:[]
			}

			break;

		/*
	case types.DOWNLOAD_DATA_FINANCIAL:
		return {
			...state,
			fileDownload:action.payload,
		};*/

		default:
			return state;
	}
};
